<div class="card-container" (click)="navigateToDetails()">
  <div class="image-container">
    <!-- TODO PINTO BIEN JPG PERO SI VIENE webp  no lo pinto  VER CON ARQUITECTURA -->
    <img class="image" [src]="image" alt="Imagen de la tarjeta" (error)="image = './assets/home/image-error.png'" />
  </div>

  <div class="content-container">
    <div class="category-reactions d-flex justify-content-between align-center">
      <div class="category-cont" [ngStyle]="{
          'background-color': categoryBackgroundColor,
          'color': categoryFontColor || '#000'
        }">
        {{ category }}
      </div>

      <div (click)="$event.stopPropagation()">
        <app-reactions [reactions]="reactions"></app-reactions>
      </div>
    </div>

    <h3 class="title">{{ title }}</h3>


    <p class="date-inscription" *ngIf="openDate && endDate">
      Inscripciones {{ openDate }} - {{ endDate }}
    </p>

    <p class="description">{{ textContent }}</p>

    <p class="max-entries sold-out" *ngIf="isSoldOut">
      <i class="fa fa-ban" aria-hidden="true"></i>
      Plazas agotadas
    </p>

    <p class="max-entries" *ngIf="maxEntries && allowedInscription">
      Plazas disponibles:
      <span class="max-entries__value">{{ maxEntries }}</span>

      <span *ngIf="isUserRegistered" class="text-success">
        Inscrito
      </span>
    </p>

    <div class="see-details">
      <p class="see-details-text">Ver detalles</p>
      <span class="icon-circle">
        <i class="fa-solid fa-chevron-right"></i>
      </span>
    </div>

  </div>
</div>
